// extracted by mini-css-extract-plugin
module.exports =  {"section":"_93444fe79c--section--JkXaE","container":"_93444fe79c--container--lIEF5"};